import { render, staticRenderFns } from "./AddOrUpdateMemberTypeModal.vue?vue&type=template&id=7b72e24a"
import script from "./AddOrUpdateMemberTypeModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateMemberTypeModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateMemberTypeModal.vue?vue&type=style&index=0&id=7b72e24a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports